var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import { AddIcon, DownloadIcon, EditIcon } from '../atoms/Icons';
/* eslint-disable react/display-name */
var tableIcons = {
    Add: forwardRef(function (props, ref) { return React.createElement(AddIcon, __assign({}, props, { ref: ref })); }),
    Check: forwardRef(function (props, ref) { return React.createElement(Check, __assign({}, props, { ref: ref })); }),
    Clear: forwardRef(function (props, ref) { return React.createElement(Clear, __assign({}, props, { ref: ref })); }),
    Delete: forwardRef(function (props, ref) { return React.createElement(DeleteOutline, __assign({}, props, { ref: ref })); }),
    DetailPanel: forwardRef(function (props, ref) { return (React.createElement(ChevronRight, __assign({}, props, { ref: ref }))); }),
    Edit: forwardRef(function (props, ref) { return React.createElement(EditIcon, __assign({}, props, { ref: ref })); }),
    Export: forwardRef(function (props, ref) { return React.createElement(DownloadIcon, __assign({}, props, { ref: ref })); }),
    Filter: forwardRef(function (props, ref) { return React.createElement(FilterList, __assign({}, props, { ref: ref })); }),
    FirstPage: forwardRef(function (props, ref) { return React.createElement(FirstPage, __assign({}, props, { ref: ref })); }),
    LastPage: forwardRef(function (props, ref) { return React.createElement(LastPage, __assign({}, props, { ref: ref })); }),
    NextPage: forwardRef(function (props, ref) { return React.createElement(ChevronRight, __assign({}, props, { ref: ref })); }),
    PreviousPage: forwardRef(function (props, ref) { return (React.createElement(ChevronLeft, __assign({}, props, { ref: ref }))); }),
    ResetSearch: forwardRef(function (props, ref) { return React.createElement(Clear, __assign({}, props, { ref: ref })); }),
    Search: forwardRef(function (props, ref) { return React.createElement(Search, __assign({}, props, { ref: ref })); }),
    SortArrow: forwardRef(function (props, ref) { return React.createElement(ArrowDownward, __assign({}, props, { ref: ref })); }),
    ThirdStateCheck: forwardRef(function (props, ref) { return React.createElement(Remove, __assign({}, props, { ref: ref })); }),
    ViewColumn: forwardRef(function (props, ref) { return React.createElement(ViewColumn, __assign({}, props, { ref: ref })); }),
};
/* eslint-enable react/display-name */
export default tableIcons;
